// /brands page used for SEO, it must be fetched for bots only
export const initialState = []
